
import { useState } from 'react';

export default function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    window.open('https://api.whatsapp.com/send?phone=551974098245', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-fade-in-up">
      {/* Mascote atrás do botão */}
      <div className="absolute -top-[90px] right-0 w-[80px] h-[100px] z-0 pointer-events-none">
        <img
          src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/0b98b1ac224741af216ca18b66494178.png"
          alt="Mascote"
          className="w-full h-full object-contain object-bottom"
        />
      </div>

      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group relative bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 flex items-center justify-center whitespace-nowrap cursor-pointer z-10"
        style={{
          width: isHovered ? '200px' : '60px',
          height: '60px',
          transition: 'all 0.3s ease-in-out',
        }}
        aria-label="Contato pelo WhatsApp"
      >
        {/* Ícone do WhatsApp */}
        <div className="absolute left-0 w-16 h-16 flex items-center justify-center">
          <i className="ri-whatsapp-fill text-3xl"></i>
        </div>

        {/* Texto que aparece no hover */}
        <span
          className="ml-4 font-semibold text-sm"
          style={{
            opacity: isHovered ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out',
          }}
        >
          Fale Conosco
        </span>

        {/* Efeito de pulso */}
        {!isHovered && (
          <>
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse opacity-30"></span>
          </>
        )}
      </button>
    </div>
  );
}
